<template>
  <v-card v-if="toolOrder">
    <v-card-text>
      <v-alert
        v-if="isFirstOrder"
        type="warning"
        colored-border
        border="left"
        elevation="2"
        class="mb-4"
        prominent
        color="amber darken-2"
      >
        <div class="d-flex align-center">
          <v-icon left large color="amber darken-4">priority_high</v-icon>
          <div>
            <strong class="text-h6">PRIORITY - First Tool Order</strong>
            <div class="body-2">
              This is the first tool order for this job site. Please prioritize
              fulfillment.
            </div>
          </div>
        </div>
      </v-alert>
      <h1 class="title">
        Order #{{ toolOrder.orderNumber }}
        <span class="grey--text font-weight-regular">
          on
          {{ toolOrder.orderDate.toDate() | moment("MMM Do [at] h:mma YYYY") }}
          <v-chip
            class="ml-1"
            small
            dark
            v-show="!incomplete()"
            color="green lighten-1"
            >Order Complete</v-chip
          >
          <v-chip
            class="ml-1"
            small
            dark
            v-show="toolOrder.cancelled"
            color="grey darken-2"
            >Order Cancelled</v-chip
          >
        </span>
      </h1>
      <v-simple-table dense class="order-details-table mt-3">
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                Ordered By:
              </td>
              <td>
                {{ toolOrder.orderedBy.firstName }}
                {{ toolOrder.orderedBy.lastName }}
                <br />
                <a :href="`mailto:${toolOrder.orderedBy.email}`">
                  {{ toolOrder.orderedBy.email }}
                </a>
                <br />
                {{ toolOrder.orderedBy.phone }}
              </td>
            </tr>
            <tr>
              <td class="pa-1 pl-0 grey--text" valign="top" width="85">
                Address:
              </td>
              <td>
                <span
                  v-if="toolOrder.jobSite.entity"
                  class="caption grey--text text--darken-1 mr-2"
                  >({{ toolOrder.jobSite.entity }})</span
                >{{ toolOrder.jobSite.address }}
              </td>
            </tr>
            <tr>
              <td class="pa-1 pl-0 grey--text" valign="top">Notes:</td>
              <td>
                {{ toolOrder.notes }}
                <div v-if="toolOrder.notes && admin" class="mb-1">
                  <span class="brown--text yard-msg">
                    <strong>*YARD MANAGERS</strong>: If tools are listed in the
                    notes. Please add them to the order before fulfillment.
                  </span>
                </div>
              </td>
            </tr>
            <tr v-for="f of toolOrder.fulfillments" :key="f.id">
              <td class="pa-1 pl-0 grey--text" valign="top">Fulfillment:</td>
              <td>
                {{ f.id | moment("MMM Do [at] h:mma") }}
                <span v-if="f.fulfilledBy">
                  by {{ f.fulfilledBy.firstName }}
                  {{ f.fulfilledBy.lastName }}
                </span>
                <div v-if="f.fulfillmentNote" class="caption grey--text">
                  Note: {{ f.fulfillmentNote }}
                </div>
              </td>
            </tr>
            <tr v-if="consumablesCost > 0">
              <td class="pa-1 pl-0 grey--text" valign="top">
                Cost of Consumables:
              </td>
              <td>
                <strong style="border-bottom: solid 3px orange"
                  >${{ utils.numberWithCommas(consumablesCost) }}
                </strong>
                &nbsp; ( fulfilled ${{
                  utils.numberWithCommas(consumablesCostFulfilled)
                }}
                )
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { sum, sumBy } from "lodash";
import utils from "@/helpers/utils";
export default {
  props: ["toolOrder", "admin", "incomplete", "isFirstOrder"],
  data() {
    return {
      utils,
    };
  },
  computed: {
    consumablesCost() {
      let consumables = this.toolOrder.tools.filter((nc) => nc.consumable);
      const val = consumables.map(
        (nc) => parseFloat(nc.unitPrice) * parseFloat(nc.qty),
        2
      );
      return sum(val).toFixed(2);
    },
    consumablesCostFulfilled() {
      let consumables = this.toolOrder.tools.filter((nc) => nc.consumable);
      const val = consumables.map(
        (nc) => parseFloat(nc.unitPrice) * parseFloat(this.fulfilledAmount(nc)),
        2
      );
      return sum(val).toFixed(2);
    },
  },
  methods: {
    fulfilledAmount(tool) {
      if (!tool.fulfillments) tool.fulfillments = [];
      if (!tool.fulfillments.length) {
        return tool.qtyFulfilled || 0;
      } else {
        return sumBy(tool.fulfillments, "qty");
      }
    },
  },
};
</script>
<style scoped>
.yard-msg {
  background: #fff4de;
  border-radius: 5px;
  padding: 3px 10px 3px 5px;
}
</style>
